import { useQuery } from "@apollo/client";
import React from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { GetLuxeDetails } from "src/graphql/queries";
import useAppStore from "src/store/utils";
import { DescribeLuxe } from "src/types/api";
import PaymentFlow from "../../pages/access-control/Modals/paymentFlow";
import DialogModal from "../Dialog";

interface Props {
  openPaymentFlow: boolean;
  setOpenPaymentFlow: React.Dispatch<React.SetStateAction<boolean>>;
}

const PaymentFlowModal = ({ openPaymentFlow, setOpenPaymentFlow }: Props) => {
  const navigate = useNavigate();
  const { event } = useAppStore((state) => state);

  const { data, loading } = useQuery<DescribeLuxe>(GetLuxeDetails, {
    fetchPolicy: "network-only",
    variables: { event_id: event?.uuid },
    onError(error) {
      if (error?.message !== "unauthenticated") {
        toast.error(
          <p className="toast">{error?.message ?? "An error occured"}</p>
        );
      } else {
        navigate("/clear");
      }
    },
  });
  return (
    <DialogModal
      open={openPaymentFlow}
      onOpenChange={setOpenPaymentFlow}
      // trigger={}
    >
      <PaymentFlow
        setOpen={setOpenPaymentFlow}
        cost={data?.describeLuxe?.discounted_amount}
        currency={data?.describeLuxe?.currency}
      />
    </DialogModal>
  );
};

export default PaymentFlowModal;
